export const TAG_COLORS = [
  '#6B7280',
  '#DC2626',
  '#EA580C',
  '#EAB308',
  '#65A30D',
  '#2563EB',
  '#7C3AED',
  '#DB2777',
  '#0D9488',
]

export const DEFAULT_TAG_COLOR = TAG_COLORS[0]
